import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatApiError } from "@/lib/api";
import StarPicker from "@/components/common/StarPicker";

const EMPTY = { category: "stocks", rating: 5, location: "", quote: "" };

export default function TestimonialDialog({ open, onOpenChange }) {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm(EMPTY); }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/testimonials", form);
      toast.success("Thank you! Your testimonial will appear once it's reviewed.");
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-line bg-panel sm:max-w-md" data-testid="testimonial-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Share your experience</DialogTitle>
          <DialogDescription>Your first name and last initial are shown with your testimonial after review.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label>Investment type</Label>
            <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
              <SelectTrigger className="field" data-testid="testimonial-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="stocks" data-testid="testimonial-category-stocks">Stocks</SelectItem>
                <SelectItem value="real_estate" data-testid="testimonial-category-real-estate">Real estate</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2"><Label>Rating</Label><StarPicker value={form.rating} onChange={(r) => setForm({ ...form, rating: r })} testIdPrefix="testimonial" /></div>
          <div className="space-y-2">
            <Label htmlFor="t-location">City (optional)</Label>
            <Input id="t-location" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className="field" data-testid="testimonial-location-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="t-quote">Your testimonial</Label>
            <Textarea id="t-quote" required minLength={20} maxLength={500} rows={4} value={form.quote} onChange={(e) => setForm({ ...form, quote: e.target.value })}
              className="rounded-xl border-line bg-surface" data-testid="testimonial-quote-input" />
            <p className="text-right font-mono text-xs text-slate-500">{form.quote.length}/500</p>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="testimonial-submit-button">{busy ? "Sending..." : "Submit testimonial"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
